import type { AiCrawlerLineup } from '../shared';

export const CATEGORY_TO_CRAWLER_IDS: Record<string, readonly string[]> = {
  chatgpt: ['gptbot', 'chatgpt'],
  claude: ['claudebot', 'claude-web', 'claude-user', 'anthropic-ai'],
  gemini: ['google-extended'],
  'perplexity-ai': ['perplexitybot', 'perplexity-user'],
  amazon: ['amazonbot'],
};

// Null prototype because lookups are keyed by URL-controlled crawler ids: a
// crafted id like `constructor` must miss instead of surfacing an
// Object.prototype member.
export const CRAWLER_ID_TO_CATEGORY: Record<string, string> = Object.assign(
  Object.create(null),
  Object.fromEntries(
    Object.entries(CATEGORY_TO_CRAWLER_IDS).flatMap(([category, ids]) =>
      ids.map((id) => [id, category])
    )
  )
);

export function crawlerIdsInLineup(
  lineup: AiCrawlerLineup,
  crawlerIds: readonly string[]
): string[] | undefined {
  const inLineup = crawlerIds.filter((id) => lineup.categories.includes(CRAWLER_ID_TO_CATEGORY[id]));
  return inLineup.length > 0 ? inLineup : undefined;
}
